import { useEffect } from 'react';
import { useAccordionItem } from '@ally/metronome-ui';
export function useAccordionClose(props) {
    const { accordionId, activeAccordion, updateAccordionState } = props;
    const { closePanel, isExpanded } = useAccordionItem();
    useEffect(() => {
        if (isExpanded && activeAccordion !== accordionId) {
            closePanel();
        }
    }, [activeAccordion]);
    useEffect(() => {
        if (isExpanded) {
            updateAccordionState(accordionId);
        }
    }, [isExpanded]);
}
//# sourceMappingURL=useAccordionClose.js.map